module.exports = __webpack_public_path__ + "static/media/Glike.3e9e0546.svg";